import React from 'react';
import { Button } from '../components/ui/button';
import { Check } from 'lucide-react';
import { APPLY_URL } from '../config';

const Amenities = () => {

  const apartmentFeatures = [
    'Brand-new with premium finishes',
    'Air conditioning and heating',
    'In-unit washer and dryer',
    'Oversized windows and abundant natural light',
    'Gourmet kitchens with stainless steel appliances',
    'Spa style bathrooms with tiled shower tubs',
    'Microwaves',
    'Dishwashers',
    'Refrigerator and freezer',
    'Quartz countertops',
    'Hardwood style floors',
    'Spacious studio, 1-, 2-, and 3-bedroom layouts'
  ];

  const communityFeatures = [
    'On-site parking included',
    'Adjacent to two AppalCART bus stops',
    'Live directly across from Appalachian State University',
    'Walk to restaurants and coffee',
    'Choose a home on or just above King Street',
    'Park on site / long-term bike storage',
    'Experience downtown Boone shops and everyday essentials at your doorstep',
    'Enjoy in a safe, residential area'
  ];

  return (
    <div className="w-full">
      {/* Hero Section */}
      <section className="py-16 md:py-24 bg-white">
        <div className="container mx-auto px-4 max-w-7xl">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1">
              <img 
                src="https://customer-assets.emergentagent.com/job_cross-domain-deploy/artifacts/6qsnm5ma_Hompage%20Luxury%20amenities.png"
                alt="Modern kitchen with natural light"
                className="w-full h-[500px] object-cover rounded-sm shadow-lg"
              />
            </div>
            <div className="order-1 lg:order-2">
              <p className="text-[#FF5722] font-semibold text-sm md:text-base tracking-wider uppercase mb-4">
                THE SUMMIT ON KING
              </p>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-8 text-black leading-tight">
                ENJOY UNPARALLELED COMFORT
              </h1>
              <p className="text-lg md:text-xl text-black leading-relaxed">
                Step into modern apartments with spacious layouts and quality finishes. Designed for students and professionals alike, The Summit on King features oversized windows, spa-style bathrooms, and gourmet kitchens with stainless steel appliances. On King Street or just above it, choose the home that fits your pace.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Apartment Features Section */}
      <section className="py-16 md:py-24 bg-gray-50">
        <div className="container mx-auto px-4 max-w-7xl">
          <div className="grid lg:grid-cols-2 gap-12 items-start">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold mb-2">
                <span className="text-[#FF5722]">APARTMENT</span>
                <br />
                <span className="text-black">FEATURES</span>
              </h2>
              <p className="text-lg md:text-xl text-black mb-8 font-medium">
                Designed for comfort, convenience, and everyday living:
              </p>
              <div className="space-y-4 mb-10">
                {apartmentFeatures.map((feature, index) => (
                  <div key={index} className="flex items-start space-x-3">
                    <Check className="w-5 h-5 text-[#FF5722] flex-shrink-0 mt-1" />
                    <span className="text-black text-base">{feature}</span>
                  </div>
                ))}
              </div>
              <Button 
                asChild
                className="bg-[#FF5722] hover:bg-white text-white hover:text-[#FF5722] border-2 border-[#FF5722] px-8 py-6 text-base font-semibold uppercase transition-all duration-200"
              >
                <a href={APPLY_URL} target="_blank" rel="noopener noreferrer" data-testid="amenities-apply-button">
                  APPLY NOW
                </a>
              </Button>
            </div>
            <div className="flex items-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_cross-domain-deploy/artifacts/c68qyj34_RBS-The%20View%20Apts-101-0007.jpg"
                alt="Modern bathroom with marble tiles"
                className="w-full h-[700px] object-cover rounded-sm shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Community Features Section */}
      <section className="py-16 md:py-24 bg-white">
        <div className="container mx-auto px-4 max-w-7xl">
          <div className="grid lg:grid-cols-2 gap-12 items-start">
            <div className="order-2 lg:order-1">
              <img 
                src="https://customer-assets.emergentagent.com/job_cross-domain-deploy/artifacts/r5fgh5uw_Downtown%20full%20campus%20view%20copy.jpg"
                alt="Aerial view of The Summit on King and Appalachian State University"
                className="w-full h-auto object-contain rounded-sm shadow-lg"
              />
            </div>
            <div className="order-1 lg:order-2">
              <h2 className="text-4xl md:text-5xl font-bold mb-2">
                <span className="text-[#FF5722]">COMMUNITY</span>
                <br />
                <span className="text-black">FEATURES</span>
              </h2>
              <p className="text-lg md:text-xl text-black mb-8 leading-relaxed">
                Live at Boone's most walkable address and enjoy easy immediate access to App State, shopping, dining and everyday essentials!
              </p>
              <div className="space-y-4">
                {communityFeatures.map((feature, index) => (
                  <div key={index} className="flex items-start space-x-3">
                    <Check className="w-5 h-5 text-[#FF5722] flex-shrink-0 mt-1" />
                    <span className="text-black text-base">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Amenities;
